import { Button } from '@viapeople/components'
import type { ReactNode } from 'react'

interface WizardNavigationProps {
	currentStep: number
	onBack: () => void
	onClose: () => void
	actionButton: ReactNode
}

export function WizardNavigation({ currentStep, onBack, onClose, actionButton }: Readonly<WizardNavigationProps>) {
	return (
		<>
			<div className='h-px bg-neutral-100 w-full' />
			<div className='flex items-center justify-between pt-4'>
				<div>
					{currentStep > 0 && (
						<Button variant='secondary' onClick={onBack}>
							← Back
						</Button>
					)}
				</div>
				<div className='flex gap-3'>
					<Button variant='secondary' onClick={onClose}>
						Cancel
					</Button>
					{actionButton}
				</div>
			</div>
		</>
	)
}
